var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import PlaceholderImg from './loading.gif';
var imageObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            var image = entry.target;
            if (image.dataset.src) {
                image.src = image.dataset.src;
            }
            observer.unobserve(image);
        }
    });
}, {
    rootMargin: '50px 0px 0px',
});
export var LazyImage = function (_a) {
    var isLazyLoading = _a.isLazyLoading, placeholderSrc = _a.placeholderSrc, src = _a.src, restProps = __rest(_a, ["isLazyLoading", "placeholderSrc", "src"]);
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            if (isLazyLoading === undefined || isLazyLoading) {
                imageObserver.observe(ref.current);
            }
            else if (src) {
                var img = new Image();
                img.src = src;
                img.onload = function () {
                    ref.current.src = src;
                };
            }
        }
    }, [isLazyLoading, src]);
    return _jsx("img", __assign({ src: placeholderSrc || PlaceholderImg, "data-src": src, ref: ref }, restProps));
};
